import * as React from 'react';
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {addCommas, handleScrollIntoView, removeNonNumeric, useShowMessageComponent} from "../assets/js/main";
import {Autocomplete, Checkbox, CircularProgress, FormControlLabel, FormGroup, Radio, RadioGroup, Stack, Switch, TextField, Typography, Divider, Box} from "@mui/material";
import NavBar from "../components/NavBar";
import {setLoading} from "../redux/loading/actions";
import {useSnackbar} from "notistack";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import {Clear, Payment} from "@mui/icons-material";
import HandleFetchData from "../plugin/HandleFetchData";
import {PatternFormat} from "react-number-format";
import DateObject from "react-date-object";
import gregorian from "react-date-object/calendars/gregorian";
import gregorian_en from "react-date-object/locales/gregorian_en";
import Captcha from "../components/Captcha";
import {ThemeContext} from "../App";

export default function Employment(props) {
  const {t} = useTranslation();
  const theme = React.useContext(ThemeContext)
  const dispatch = useDispatch();
  const selector = useSelector((st) => st)
  const {enqueueSnackbar} = useSnackbar();
  const {fetchData} = HandleFetchData()
  const {showMessageComponent} = useShowMessageComponent()

  const ref1 = React.useRef()
  const ref2 = React.useRef()
  const ref3 = React.useRef()
  const ref4 = React.useRef()
  const ref5 = React.useRef()
  const ref6 = React.useRef()
  const ref7 = React.useRef()
  const ref8 = React.useRef()
  const ref9 = React.useRef()
  const ref10 = React.useRef()
  const ref11 = React.useRef()
  const ref12 = React.useRef()
  const ref13 = React.useRef()
  const ref14 = React.useRef()
  const ref15 = React.useRef()
  const ref16 = React.useRef()
  const ref17 = React.useRef()
  const ref18 = React.useRef()
  const childRef = React.useRef();

  const [firstName, setFirstName] = React.useState('');
  const [lastName, setLastName] = React.useState('');
  const [listStateAndCity, setListStateAndCity] = React.useState([])
  const [textStateAndCity, setTextStateAndCity] = React.useState('')
  const [newStateAndCity, setNewStateAndCity] = React.useState(null)
  const [birthDate, setBirthDate] = React.useState(null)
  const [nationalCodeSerial, setNationalCodeSerial] = React.useState('');
  const [evidence, setEvidence] = React.useState("");
  const [university, setUniversity] = React.useState("");
  const [study, setStudy] = React.useState("");
  const [duty, setDuty] = React.useState("");
  const [married, setMarried] = React.useState("");
  const [experience, setExperience] = React.useState("");
  const [rights, setRights] = React.useState("");
  const [english, setEnglish] = React.useState("");

  const [address, setAddress] = React.useState('');
  const [mobileNo, setMobileNo] = React.useState('');
  const [phoneNo, setPhoneNo] = React.useState('');
  const [email, setEmail] = React.useState(null);
  const [fileBase, setFileBase] = React.useState('');
  const [file, setFile] = React.useState('');


  const [department, setDepartment] = React.useState('');


  const [departments, setDepartments] = React.useState([]);

  const [validations, setValidations] = React.useState({});

  React.useEffect(() => {
    handleGetDepartment()
    getStateAndCity()
  }, [])

  const validationInput = () => {
    if (!firstName) {
      handleScrollIntoView(ref1)
      setValidations({
        firstName: 'نام الزامی می باشد'
      })
    } else if (!lastName) {
      handleScrollIntoView(ref2)
      setValidations({
        lastName: 'نام خانوادگی الزامی می باشد'
      })
    } else if (!mobileNo) {
      handleScrollIntoView(ref4)
      setValidations({
        mobileNo: 'شماره همراه الزامی می باشد'
      })
    } else if (!department) {
      handleScrollIntoView(ref5)
      setValidations({
        department: ' انتخاب بخش الزامی می باشد'
      })
    } else if (!newStateAndCity) {
      handleScrollIntoView(ref6)
      setValidations({
        newStateAndCity: 'شهر و استان الزامی می باشد'
      })
    } else if (!birthDate) {
      handleScrollIntoView(ref7)
      setValidations({
        birthDate: 'تاریخ تولد الزامی می باشد'
      })
    } else if (!evidence) {
      handleScrollIntoView(ref8)
      setValidations({
        evidence: 'مدرک تحصیلی الزامی می باشد'
      })
    } else if (!duty) {
      handleScrollIntoView(ref11)
      setValidations({
        duty: 'وضعیت نظام وظیفه الزامی می باشد'
      })
    } else if (!married) {
      handleScrollIntoView(ref12)
      setValidations({
        married: 'وضعیت تاهل الزامی می باشد'
      })
    } else if (!english) {
      handleScrollIntoView(ref15)
      setValidations({
        english: 'میزان آشنایی به زبان انگلیسی الزامی می باشد'
      })
    } else if (!address) {
      handleScrollIntoView(ref16)
      setValidations({
        address: 'آدرس الزامی می باشد'
      })
    } else if (!fileBase || !file) {
      handleScrollIntoView(ref17)
      setValidations({
        resume: 'انتخاب فایل رزومه الزامی می باشد'
      })
    }else if (!childRef.current.checkCaptcha()){
      handleScrollIntoView(ref18)
      setValidations({
        captcha: 'کپچا را به درستی وارد کنید'
      })

    }else {
      handleSendRequest()
    }
  }

  // متد دریافت لیست استان ها
  const getStateAndCity = async (e) => {
    dispatch(setLoading(true))
    let fetch = await fetchData('nbl', 'GET', `/v1/Address/getStateCity`, '', "application/json", {
      "term": e
    }, 'postex')
    setListStateAndCity(fetch?.data)
    dispatch(setLoading(false))
  }

  const handleGetDepartment = async () => {
    dispatch(setLoading(true))
    let fetch = await fetchData('ticketing', 'GET', `/v1/Employment/GetSections`, '',
       "application/json", '', 'postex', "HiTicketPostexAdmin@1402")

    // console.log('fetch', fetch)
    if (fetch?.success) {
      setDepartments(fetch?.data)
    }
    dispatch(setLoading(false))
  }


  const handleSendRequest = async (e) => {
    dispatch(setLoading(true))
    let fetch = await fetchData('ticketing', 'POST', `/v1/Employment`,
       {
         "firstName": firstName,
         "lastName": lastName,
         "phoneNumber": phoneNo,
         "mobileNumber": mobileNo,
         "email": email,
         "section": Number(department),
         "provinceId": Number(newStateAndCity?.id?.split('-')[0]),
         "cityId": Number(newStateAndCity?.id?.split('-')[1]),
         "address": address,
         "degreeOfEducation": evidence,
         "university": university,
         "militaryStatus": duty,
         "marriedStatus": married,
         "birthDate": birthDate ? new DateObject(birthDate).convert(gregorian, gregorian_en).format("YYYY-MM-DDThh:mm:ss") : "",
         "experience": experience,
         "salary": rights,
         "familiarityWithLanguage": english,
         "byteAttachmentFile": fileBase,
         "attachmentFile": fileBase,
       },
       "application/json", '', 'postex', "HiTicketPostexAdmin@1402"
    )

    if (fetch?.success) {
      showMessageComponent(fetch?.message || t("msg.t7"), 'success')
      window.location.reload();

    }
    dispatch(setLoading(false))
  }


  function onFileChange(event) {
    if (event?.target?.files?.length) {
      if(event?.target?.files[0].size > 20000){
        showMessageComponent(t("error.t45"), 'error')
      }else{
        setFile(event?.target?.files[0])
        const reader = new FileReader()
        reader?.readAsDataURL(event?.target?.files[0])
        reader.onload = () => {
          setFileBase(reader?.result)
        }
      }
    }

  }


  return (
     <>
       <NavBar blue back/>

       {selector?.loading?.isLoading &&
          <div className="backdrop-loading">
            <div className="backdrop-bg">
              <div className="loader" style={theme.darkMode ? {backgroundImage: "url('/splash2.gif')"} : {backgroundImage: "url('/splash1.gif')"}}/>
            </div>
          </div>
       }

       <div className="container">
         <div className="agencyRequestPage">
           <div className="titlePage">
             <h1>{t("employment.t1")}</h1>
           </div>
           <div className="form">

             <div className="row">
               <div className="col-12 col-md-6 col-lg-4">
                 <div className="input">
                   <label className="required">{t("employment.t3")}</label>
                   <input type="text" name="firstName" id="firstName" ref={ref1}
                          value={firstName}
                          onChange={e => setFirstName(e.target.value)}/>
                   {
                      validations?.firstName &&
                      <p className="error">{validations?.firstName}</p>
                   }
                 </div>
               </div>
               <div className="col-12 col-md-6 col-lg-4">
                 <div className="input">
                   <label className="required">{t("employment.t4")}</label>
                   <input type="text" name="lastName" id="lastName" ref={ref2}
                          value={lastName}
                          onChange={e => setLastName(e.target.value)}/>
                   {
                      validations?.lastName &&
                      <p className="error">{validations?.lastName}</p>
                   }
                 </div>
               </div>
               <div className="col-12 col-md-6 col-lg-4">
                 <div className="input">
                   <label>{t("employment.t5")}</label>
                   <input type="text" name="phoneNo" className="numeric" id="phoneNo" ref={ref3}
                          value={phoneNo}
                          onChange={e => e?.target?.value?.length <= 11 && setPhoneNo(removeNonNumeric(e.target.value))}/>
                 </div>
               </div>
               <div className="col-12 col-md-6 col-lg-4">
                 <div className="input">
                   <label className="required">{t("employment.t6")}</label>
                   <input type="text" name="mobileNo" className="numeric" inputMode='numeric' id="mobileNo"
                          value={mobileNo} ref={ref4}
                          onChange={e => e?.target?.value?.length <= 11 && setMobileNo(removeNonNumeric(e.target.value))}/>
                   {
                      validations?.mobileNo &&
                      <p className="error">{validations?.mobileNo}</p>
                   }
                 </div>
               </div>
               <div className="col-12 col-md-6 col-lg-4">
                 <div className="input">
                   <label>{t("employment.t7")}</label>
                   <input type="email" name="email" id="email"
                          value={email}
                          onChange={e => setEmail(e.target.value)}/>
                 </div>
               </div>
               <div className="col-12 col-md-6 col-lg-4">
                 <div className="input">
                   <label className="required">{t("employment.t8")}</label>
                   <select aria-label="Default select example" value={department} id="department" ref={ref5}
                           onChange={e => setDepartment(e.target.value)}>
                     <option value="" selected disabled>{t("homeDesktop.s1.t4.tt10")}</option>
                     {
                       departments?.map(item => <option value={item?.code} key={item?.code}>{item?.title}</option>)
                     }
                   </select>
                   {
                      validations?.department &&
                      <p className="error">{validations?.department}</p>
                   }
                 </div>
               </div>
               <div className="col-12 col-md-6 col-lg-4">
                 <div className="input mb-3">
                   <label className="required">{t("employment.t9")}</label>
                   <Autocomplete
                      ref={ref6}
                      inputValue={textStateAndCity}
                      noOptionsText={t("autoComplete.t1")}
                      id="stateAndCity"
                      disablePortal
                      autoHighlight
                      loading={selector?.loading?.isLoading}
                      onChange={(e, value, reason) => {
                        if (reason === 'clear') {
                          setTextStateAndCity('')
                          setNewStateAndCity(null)
                        } else {
                          setTextStateAndCity(value?.name)
                          setNewStateAndCity(value)
                        }
                      }}
                      options={listStateAndCity || []}
                      getOptionLabel={(option) => option?.name}
                      renderInput={(params) =>
                         <TextField {...params}
                                    hiddenLabel
                                    size="small"
                                    placeholder={t("singleOrder.sender.t28")}
                                    onChange={(event) => {
                                      setTextStateAndCity(event?.target?.value)
                                      event?.target?.value?.length > 2 && getStateAndCity(event?.target?.value)
                                    }}
                                    InputProps={{
                                      ...params.InputProps,
                                      endAdornment: (
                                         <React.Fragment>
                                           {selector?.loading?.isLoading ? <CircularProgress style={{margin: '0 5px'}} size={20}/> : null}
                                           {params.InputProps.endAdornment}
                                         </React.Fragment>
                                      ),
                                    }}
                         />}
                   />
                   {
                      validations?.newStateAndCity &&
                      <p className="error">{validations?.newStateAndCity}</p>
                   }
                 </div>
               </div>
               <div className="col-12 col-md-6 col-lg-4">
                 <div className="input">
                   <label className="required">{t("employment.t26")}</label>
                   <div className="date-picker" ref={ref7}>
                     <DatePicker
                        id="setBirthDate"
                        calendar={persian}
                        locale={persian_fa}
                        value={birthDate}
                        onChange={e => setBirthDate(e)}
                     />
                     <button type="button" onClick={() => setBirthDate(null)} id="toDate">
                       <Clear/>
                     </button>
                   </div>
                   {
                      validations?.birthDate &&
                      <p className="error">{validations?.birthDate}</p>
                   }
                 </div>
               </div>
               <div className="col-12 col-md-6 col-lg-4">
                 <div className="input">
                   <label className="required">{t("employment.t11")}</label>
                   <select aria-label="Default select example" value={evidence} id="evidence" ref={ref8}
                           onChange={e => setEvidence(e.target.value)}>
                     <option value="" selected disabled>{t("homeDesktop.s1.t4.tt10")}</option>
                     <option value="0">{t("employment.t12")}</option>
                     <option value="1">{t("employment.t13")}</option>
                     <option value="2">{t("employment.t14")}</option>
                     <option value="3">{t("employment.t15")}</option>
                     <option value="4">{t("employment.t16")}</option>

                   </select>
                   {
                      validations?.evidence &&
                      <p className="error">{validations?.evidence}</p>
                   }
                 </div>
               </div>
               <div className="col-12 col-md-6 col-lg-4">
                 <div className="input">
                   <label>{t("employment.t17")}</label>
                   <input type="text" name="university" ref={ref9} id="university" onChange={(e) => setUniversity(e.target.value)}
                          value={university}/>
                 </div>
               </div>
               <div className="col-12 col-md-6 col-lg-4">
                 <div className="input">
                   <label>{t("employment.t18")}</label>
                   <input type="text" name="study" ref={ref10} id="study" onChange={(e) => setStudy(e.target.value)}
                          value={study}/>
                   {
                      validations?.study &&
                      <p className="error">{validations?.study}</p>
                   }
                 </div>
               </div>
               <div className="col-12 col-md-6 col-lg-4">
                 <div className="input">
                   <label className="required">{t("employment.t19")}</label>
                   <select aria-label="Default select example" value={duty} id="duty" ref={ref11}
                           onChange={e => setDuty(e.target.value)}>
                     <option value="" selected disabled>{t("homeDesktop.s1.t4.tt10")}</option>
                     <option value="0">{t("employment.t20")}</option>
                     <option value="1">{t("employment.t21")}</option>
                     <option value="2">{t("employment.t22")}</option>
                   </select>
                   {
                      validations?.duty &&
                      <p className="error">{validations?.duty}</p>
                   }
                 </div>
               </div>
               <div className="col-12 col-md-6 col-lg-4">
                 <div className="input">
                   <label className="required">{t("employment.t23")}</label>
                   <select aria-label="Default select example" value={married} id="married" ref={ref12}
                           onChange={e => setMarried(e.target.value)}>
                     <option value="" selected disabled>{t("homeDesktop.s1.t4.tt10")}</option>
                     <option value="0">{t("employment.t24")}</option>
                     <option value="1">{t("employment.t25")}</option>
                   </select>
                   {
                      validations?.married &&
                      <p className="error">{validations?.married}</p>
                   }
                 </div>
               </div>

               <div className="col-12 col-md-6 col-lg-4">
                 <div className="input">
                   <label>{t("employment.t27")}</label>
                   <input type="text" name="experience" ref={ref13} id="experience" onChange={(e) => setExperience(e.target.value)}
                          value={experience}/>
                   {
                      validations?.experience &&
                      <p className="error">{validations?.experience}</p>
                   }
                 </div>
               </div>
               <div className="col-12 col-md-6 col-lg-4">
                 <div className="input">
                   <label>{t("employment.t28")}</label>
                   <input type="text" name="rights" className="numeric" inputMode="numeric" ref={ref14} id="rights" onChange={(e) =>
                      setRights(addCommas(removeNonNumeric(e.target.value)))}
                          value={rights}/>
                   {
                      validations?.rights &&
                      <p className="error">{validations?.rights}</p>
                   }
                 </div>
               </div>

               <div className="col-12 col-md-6 col-lg-4">
                 <div className="input">
                   <label className="required">{t("employment.t29")}</label>
                   <select aria-label="Default select example" value={english} id="english" ref={ref15}
                           onChange={e => setEnglish(e.target.value)}>
                     <option value="" selected disabled>{t("homeDesktop.s1.t4.tt10")}</option>
                     <option value="0">{t("employment.t30")}</option>
                     <option value="1">{t("employment.t31")}</option>
                     <option value="2">{t("employment.t32")}</option>
                     <option value="3">{t("employment.t33")}</option>
                   </select>
                   {
                      validations?.english &&
                      <p className="error">{validations?.english}</p>
                   }
                 </div>
               </div>

               <div className="col-12 col-lg-8">
                 <div className="input">
                   <label className="required">{t("employment.t10")}</label>
                   <input type="text" name="address" ref={ref16} id="address" onChange={(e) => setAddress(e.target.value)}
                          value={address}/>
                   {
                      validations?.address &&
                      <p className="error">{validations?.address}</p>
                   }
                 </div>
               </div>

               {/*<div className="row d-flex align-items-center">*/}
                 <div className="col-12 col-lg-3 col-xl-4 mb-3">
                   <div className=" d-flex align-items-center" ref={ref17}>
                     <button className="select-file">
                       <label htmlFor="upload-file">{t("employment.t35")}</label>
                       <input type="file" name="resume" id="upload-file" onChange={onFileChange}/>
                     </button>

                     <p className="mb-0 mx-2">{file?.name || ""}</p>
                   </div>

                   {
                      validations?.resume &&
                      <p className="error">{validations?.resume}</p>
                   }
                 </div>
                 <div className="col-12 col-lg-6 col-xl-4 mb-3" ref={ref18}>
                   <Captcha ref={childRef}/>
                   {
                      validations?.captcha &&
                      <p className="error">{validations?.captcha}</p>
                   }
                 </div>
                 <div className="col-12 col-lg-3 col-xl-4 mb-3">
                   <div className="btnGroup_yellow mb-0 mt-0">
                     <button className="btnFill justify-content-center m-0" onClick={validationInput}
                             disabled={selector?.loading?.isLoading}>
                       {
                         selector?.loading?.isLoading ?
                            <Box sx={{display: 'flex'}}>
                              <CircularProgress size={20}/>
                            </Box>
                            :
                            <>
                              <span>{t("employment.t34")}</span>
                            </>
                       }
                     </button>
                   </div>
                 </div>
               </div>
             {/*</div>*/}
           </div>
         </div>
       </div>
     </>
  )
}
